'use strict';

require("core-js/modules/es6.object.is");

var implementation = require('./implementation');

module.exports = function getPolyfill() {
  return typeof Object.is === 'function' ? Object.is : implementation;
};